import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import CancelIcon from 'material-ui/svg-icons/navigation/close';
import RemoveIcon from 'material-ui/svg-icons/navigation/cancel';

class InventoryContentsTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmRemove: false,
            editing: false,
            qty: props.data.qty
        };
    }

    handleRowRemove = () => {
        this.setState({confirmRemove: true});
    };

    handleRowRemoveConfirm = () => {
        this.setState({
            confirmRemove: false
        }, () => {
            this.props.onQtyChange('remove', this.props.data.barcode, null);
        });
    };

    handleRowRemoveCancel = () => {
        this.setState({confirmRemove: false});
    };

    render() {
        const {
            data,
            viewType
        } = this.props;

        const {
            confirmRemove
        } = this.state;

        const styles = {
            confirm: {fontWeight: 600, textTransform: 'uppercase'},
            editCol: {width: 142, minWidth: 142, paddingLeft: 10, paddingRight: 10},
            iconButton: {display: 'inline-block', margin: 0, padding: 10, verticalAlign: 'middle'},
            iconButtonSmall: {
                display: 'inline-block',
                width: 42,
                height: 42,
                margin: '0 0 0 0.5em',
                padding: 4,
                verticalAlign: 'middle'
            },
            qty: {width: 30, marginRight: 6, verticalAlign: 'middle'},
            qtyEdit: {
                width: 40,
                height: 20,
                fontSize: 14,
                padding: '4px 3px 4px 6px',
                verticalAlign: 'middle',
                border: '1px solid ' + FuseTheme.palette.disabledColor,
                borderRadius: 4
            },
            rowHeight: {height: '40px'},
            columnSmall: {paddingLeft: 10, paddingRight: 10},
            columnWrap: {whiteSpace: 'inherit'}
        };

        return (
            <TableRow style={styles.rowHeight}>
                <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
                    {data.product}
                </TableRowColumn>

                <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
                    {data.barcode}
                </TableRowColumn>

                <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall, ...styles.columnWrap}}>
                    {data.product_name}
                </TableRowColumn>

                <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
                    {data.unit_type}
                </TableRowColumn>

                {viewType === 'show' &&
                    <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
                        {data.qty}
                    </TableRowColumn>
                }

                {viewType === 'edit' &&
                    <TableRowColumn style={{...styles.rowHeight, ...styles.editCol}}>
                    <span>
                        <input type="number" defaultValue={data.qty} min="1" style={styles.qtyEdit}
                               onChange={e => this.props.onQtyChange('qty', this.props.data.barcode, e.target.value)}/>
                    </span>
                    </TableRowColumn>
                }

                {viewType === 'show' &&
                    <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
                        {data.unit_qty}
                    </TableRowColumn>
                }

                {viewType === 'edit' &&
                    <TableRowColumn style={{...styles.rowHeight, ...styles.editCol}}>
                        {!confirmRemove &&
                            <IconButton
                                onClick={this.handleRowRemove}
                                style={styles.iconButton}
                            >
                                <RemoveIcon color={FuseTheme.palette.primary1Color}/>
                            </IconButton>
                        }
                        {confirmRemove &&
                            <span>
                        <span style={styles.confirm}>
                            Confirm
                        </span>
                        <IconButton
                            onClick={this.handleRowRemoveConfirm}
                            style={styles.iconButtonSmall}
                        >
                            <RemoveIcon color={FuseTheme.palette.primary1Color}/>
                        </IconButton>
                         <IconButton
                             onClick={this.handleRowRemoveCancel}
                             style={styles.iconButtonSmall}
                         >
                            <CancelIcon/>
                        </IconButton>
                    </span>
                        }
                    </TableRowColumn>
                }
            </TableRow>
        )
    }
}

InventoryContentsTableRow.propTypes = {
    data: PropTypes.object.isRequired,
    onQtyChange: PropTypes.func.isRequired,
    viewType: PropTypes.string
};

InventoryContentsTableRow.defaultProps = {
    style: {padding: 0},
    viewType: 'show'
};

export default InventoryContentsTableRow;



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryContentsTableRow.js